import Constant from '@/common/constant/Constant';
import { useEffect, useRef, useState, useCallback } from 'react';
import RenderTooltipTitles from './RenderTooltipTitles';
import FormInputWithOnChange from '../../common/form/input-with-onchange';
import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import { Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import TelephoneConstant from '@/common/constant/TelephoneConstant';

TextInput.propTypes = {
    data: PropTypes.shape({
        sysField: PropTypes.string,
        structure: PropTypes.shape({
            publicForCustomer: PropTypes.number,
            required: PropTypes.bool
        }),
        id: PropTypes.any
    }),
    formType: PropTypes.any,
    defaultValue: PropTypes.any,
    viewFromProjectOfEscalateTicket: PropTypes.bool,
    detailTicket: PropTypes.shape({
        deletedAt: PropTypes.any
    }),
    hasEditFieldPermissions: PropTypes.bool,
    isDraft: PropTypes.bool,
    name: PropTypes.string,
    register: PropTypes.func,
    setValue: PropTypes.func,
    setIsEdited: PropTypes.func,
    setShowButtonEditTicket: PropTypes.func,
    listFieldEdited: PropTypes.array,
    setListFieldEdited: PropTypes.func,
    setOnChangeEdit: PropTypes.func,
    onChangeEdit: PropTypes.any,
    isSystemSDAutoForm: PropTypes.bool,
    isTooltipTitle: PropTypes.bool,
    label: PropTypes.string,
    isShowIconCopyFieldId: PropTypes.bool,
    required: PropTypes.bool,
    errorlist: PropTypes.any,
    isDisableOnBlur: PropTypes.bool
};

export default function TextInput(props) {
    let formType = props.formType;
    let defaultValue = '';

    let autoDisableFields = ['ticketId']
    const isDisableField =
        props.data.structure.publicForCustomer === 2 ||
        autoDisableFields.includes(props.data?.sysField) ||
        props.viewFromProjectOfEscalateTicket ||
        !Utils.isEmptyString(props.detailTicket?.deletedAt) ||
        props.hasEditFieldPermissions === false;

    switch (true && !props.defaultValue) {
        case props.data.sysField === 'outline' && formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUESTDESK.OUTLINE;
            break;
        case props.data.sysField === 'outline' &&
            formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUEST_CUSTOMER.OUTLINE;
            break;
        case props.data.sysField === 'outline' && formType === Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.EXTERNAL_DESK_REQUEST.OUTLINE;
            break;
        case props.data.sysField === 'outline' && formType === Constant.FORM_TYPE.FORM_REQ_EXTERNAL_CUSTOMER:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.REQUEST_EXTERNAL_CUSTOMER.OUTLINE;
            break;

        case props.data.sysField === 'category' && formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUESTDESK.CATEGORY;
            break;
        case props.data.sysField === 'category' && formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUEST.CATEGORY;
            break;
        case props.data.sysField === 'category' &&
            formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER:
            defaultValue = 'ゲストカスタマー登録';
            break;
        case props.data.sysField === 'category' && formType === Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.EXTERNAL_DESK_REQUEST.CATEGORY;
            break;
        case props.data.sysField === 'category' && formType === Constant.FORM_TYPE.FORM_REQ_EXTERNAL_CUSTOMER:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.REQUEST_EXTERNAL_CUSTOMER.CATEGORY;
            break;
        default:
            defaultValue = props.defaultValue ? props.defaultValue : '';
            break;
    }

    if (props.defaultValue || props.isDraft) {
        defaultValue = props.defaultValue ? props.defaultValue : '';
    }

    if (
        props?.data?.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_OPERATOR_NAME &&
        !Utils.isEmptyString(props?.detailTicket?.deletedAt) &&
        !Utils.isEmptyString(defaultValue)
    ) {
        const deletedSuffix = `(${I18n.get('COMMSG069')})`;
        if (!defaultValue.includes(deletedSuffix)) {
            defaultValue = `${defaultValue} ${deletedSuffix}`;
        }
    }

    useEffect(() => {
        registerAndSetValue();
    }, []);

    useEffect(() => {
        registerAndSetValue();
    }, [defaultValue]);

    const registerAndSetValue = () => {
        if (!props?.name) {
            return;
        }

        if (props.register) {
            props.register(props?.name, {
                onChange: e => {}
            });
        }
        if (props.setValue) {
            props.setValue(props?.name, defaultValue);
        }
    };
    const handleEditTicket = e => {
        if (props?.setIsEdited) {
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket()
            if(!props?.listFieldEdited?.includes(props?.name)){
                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
            }
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
        }
    };

    let instruction = '';
    let instructionClass = '';
    if (props.data.sysField === Constant.SYS_FIELD.OUTLINE && props?.isSystemSDAutoForm)
        instruction = I18n.get('MSG-SD-INTRUCTION-SCRIPT-TITLE');

    if (props?.data?.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_OPERATOR_NAME) {
        instruction = I18n.get('AI-OPERATOR-PROMPT-INSTRUCTION');
        instructionClass = 'ai-operator-prompt-instruction font-size-14';
    }

    const className = [TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER].includes(
        props.data?.sysField
    )
        ? 'width-50-left'
        : '';

    const isTelephoneEllipsisField = [
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.FROM,
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.TO,
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER
    ].includes(props.data?.sysField);

    const inputRef = useRef(null);
    const [isOverflow, setIsOverflow] = useState(false);

    const checkOverflow = useCallback(() => {
        const el = inputRef.current;
        if (!el) return;
        requestAnimationFrame(() => {
            setIsOverflow(el.scrollWidth > el.clientWidth);
        });
    }, []);

    useEffect(() => {
        if (!isTelephoneEllipsisField || !isDisableField) return;
        const timer = setTimeout(() => {
            const el = inputRef.current?.querySelector?.('input');
            if (el) {
                inputRef.current = el;
                checkOverflow();
            }
        }, 100);
        return () => clearTimeout(timer);
    }, [defaultValue, isTelephoneEllipsisField, isDisableField, checkOverflow]);

    const telephoneEllipsisClass = isTelephoneEllipsisField ? 'telephone-ellipsis-field' : '';

    const renderInput = () => (
        <FormInputWithOnChange
            name={props?.name}
            className={`form-control-input form-control-wrapInput form-control-hg40 ${telephoneEllipsisClass}`}
            variant="outlined"
            defaultValue={defaultValue}
            autoComplete="off"
            required={props?.required}
            errorlist={props?.errorlist}
            disabled={isDisableField}
            data-cy="render-field-txt-input"
            onPaste={handleEditTicket}
            onChange={e => handleEditTicket(e)}
            isDisableOnBlur={props.isDisableOnBlur ? props.isDisableOnBlur : false}
            instruction={instruction}
            instructionClass={instructionClass}
        />
    );

    return (
        <div className={`form-addTicket ${className}`}>
            <div className="cell-prod-status gap-8">
                {props?.isTooltipTitle ? 
                    <RenderTooltipTitles {...props}/> :
                    <label className="form-addTicket-label w-f100">
                        {props?.data?.sysField === 'guestProject' && formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST ? I18n.get('USER04BTN038') : props?.label}{' '}
                        {props.data.structure.required && <span className="required">*</span>}
                    </label>
                }
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement='top' arrow>
                        <img
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
                
            </div>
            
            <div className="form-addTicket-input" ref={isTelephoneEllipsisField ? inputRef : null}>
                {isTelephoneEllipsisField && isDisableField && isOverflow ? (
                    <Tooltip title={defaultValue || ''} placement="top" arrow>
                        <div>{renderInput()}</div>
                    </Tooltip>
                ) : (
                    renderInput()
                )}
            </div>
        </div>
    );
}